import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/col/index.js
// module id = 640
// module chunks = 0